import React, { useState, useEffect } from "react";

const CustomTabs = ({ tabs = [], currentTab = 1, onTabChange }) => {
  const [activeIndex, setActiveIndex] = useState(currentTab);

  useEffect(() => {
    setActiveIndex(currentTab); 
  }, [currentTab]);


  return (
    <div className="w-full">
      <div className="flex bg-gray-100 p-2 rounded-full shadow-inner">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 text-sm text-center px-3 py-2 rounded-full transition-all duration-300 ${
              activeIndex === tab.id
                ? "bg-customGreen text-white shadow font-semibold"
                : "text-gray-600 hover:bg-white/50"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomTabs;
